// extracted by mini-css-extract-plugin
export default {"base":"base-xVLAJ","submitButton":"submitButton-yIKsY"};